import { useCallback, useEffect, useState } from 'react'
import { IManual } from '../../utils/types'
import { extractH2ContentWithIds } from '../../utils/manual-content-tag-utils'

export interface IManualMenu {
	id: string
	content: string
}

const useManualMenuNav = ({ manual }: { manual: IManual }) => {
	const [isMenuShown, setIsMenuShown] = useState(false)
	const [menuContent, setMenuContent] = useState<IManualMenu[]>([])

	const getMenuContent = useCallback(() => {
		const completeMenu: IManualMenu[] = []

		if (manual.memory_track) {
			completeMenu.push({ id: 'memory-track', content: 'Memory Track' })
		}

		const manualBodyMenu = extractH2ContentWithIds(manual.body) as IManualMenu[]
		completeMenu.push(...manualBodyMenu)

		if (manual.summary) {
			completeMenu.push({ id: 'conclusion', content: 'Conclusion' })
		}

		setMenuContent(completeMenu)
	}, [manual])

	useEffect(() => {
		getMenuContent()
	}, [manual, getMenuContent])

	const toggleMenuShow = () => {
		setIsMenuShown((prevState) => !prevState)
	}

	const closeMenu = () => {
		setIsMenuShown(false)
	}

	return { isMenuShown, menuContent, toggleMenuShow, closeMenu }
}

export default useManualMenuNav
